// START_MODULE pages_main_sections_main_main_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the animated cobweb and render a stable, non-typing subtitle.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';
import ParticlesBgExport from 'particles-bg';
import { useTheme } from 'styled-components';
import AnchorLinkExport from 'react-anchor-link-smooth-scroll';

import * as Styled from './styled';
import { ArrowDownCircle, Logo, LogoText } from './styled';

import logoWithoutText from 'assets/logoWithoutText.svg';
import logoTextSvg from 'assets/logoText.svg';

import ArrowDownIcon from 'components/atoms/icons/ArrowDownIcon';

import { Section } from 'routes/section';

const AnchorLink = (
  (AnchorLinkExport as unknown as { default?: typeof AnchorLinkExport }).default
  ?? AnchorLinkExport
) as typeof AnchorLinkExport;
const ParticlesBg = (
  (ParticlesBgExport as unknown as { default?: typeof ParticlesBgExport }).default
  ?? ParticlesBgExport
) as typeof ParticlesBgExport;

const Main: React.FC = () => {
  const { softAccentColor } = useTheme();

  return (
    <Styled.MainSectionWrapper id={Section.MAIN}>
      <Styled.HeadersWrapper>
        <Styled.MainHeaderContainer>
          <Logo src={logoWithoutText} />
          <LogoText src={logoTextSvg} />
        </Styled.MainHeaderContainer>
        <Styled.SubHeader>Мы проводим митапы</Styled.SubHeader>
      </Styled.HeadersWrapper>

      <ParticlesBg type="cobweb" bg num={300} color={softAccentColor} />

      <AnchorLink href="#description">
        <ArrowDownCircle>
          <ArrowDownIcon />
        </ArrowDownCircle>
      </AnchorLink>
    </Styled.MainSectionWrapper>
  );
};

export default Main;

// END_MODULE pages_main_sections_main_main_tsx
